import { IconChip } from '@zealot/ui/components/icon-chip';
import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

// gloss
type KpiCardProps = Omit<React.ComponentProps<'div'>, 'title'> & {
  icon: React.ReactNode;
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
  tone?: React.ComponentProps<typeof IconChip>['tone'];
};

// gloss
const KpiCard = ({ icon, label, value, hint, tone = 'default', className, ...props }: KpiCardProps) => (
  <div
    className={cn('flex min-w-0 items-start gap-3 rounded-xl border border-border/80 bg-card p-4', className)}
    {...props}
  >
    <IconChip tone={tone} size="xl" shape="square" className="border border-border">
      {icon}
    </IconChip>
    <div className="min-w-0 flex-1">
      <p className="truncate font-medium text-[11px] text-muted-foreground uppercase tracking-wide">{label}</p>
      <p className="mt-0.5 truncate font-semibold text-foreground text-xl">{value}</p>
      {hint ? <p className="mt-0.5 truncate text-muted-foreground text-xs">{hint}</p> : null}
    </div>
  </div>
);

export type { KpiCardProps };
export { KpiCard };
